module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-side content-side-full"
  }, [_c('ul', {
    staticClass: "nav-main"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'dashboard'
      }
    }
  }, [_c('i', {
    staticClass: "si si-cup"
  }), _vm._v(" "), _c('span', [_vm._v("Dashboard")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'checkout'
      }
    }
  }, [_c('i', {
    staticClass: "si si-wallet"
  }), _vm._v(" "), _c('span', [_vm._v("Showroom order")])])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'orders'
      }
    }
  }, [_c('i', {
    staticClass: "si si-basket"
  }), _vm._v(" "), _c('span', [_vm._v("Bestellingen")])])], 1), _vm._v(" "), (_vm.$auth.getUser().id === 36 || _vm.$auth.getUser().id === 40) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'refunds'
      }
    }
  }, [_c('i', {
    staticClass: "si si-control-rewind"
  }), _vm._v(" "), _c('span', [_vm._v("Retouren")])]) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'products'
      }
    }
  }, [_c('i', {
    staticClass: "si si-tag"
  }), _vm._v(" "), _c('span', [_vm._v("Producten")])])], 1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'order_lists'
      }
    }
  }, [_c('i', {
    staticClass: "si si-tag"
  }), _vm._v(" "), _c('span', [_vm._v("Inkooporders")])])], 1), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'hour_registration'
      }
    }
  }, [_c('i', {
    staticClass: "si si-clock"
  }), _vm._v(" "), _c('span', [_vm._v("UrenReigstratie")])])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-main-heading"
  }, [_c('span', [_vm._v("Orderafhandeling")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-main-heading"
  }, [_c('span', [_vm._v("Magazijn")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-main-heading"
  }, [_c('span', [_vm._v("Inkooporders")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-main-heading"
  }, [_c('span', [_vm._v("Medewerkers")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67dbe042","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layout/partials/OrderPickerSidebar.vue
// module id = 729
// module chunks = 1